import {
  $WINDOW,
  $TOPLINE,
  SCROLL_CLASS,
  LOCAL_SITE_MENU_CLASS,
  SHOW_CLASS,
  ACTIVE_CLASS,
  $BODY,
  BODY_LOCK_CLASS,
  $LOCAL_MENU,
  $DOCUMENT,
  L_TABLET_WIDTH,
  BORDER_BOTTOM_CLASS,
  DIRECTIONS_MENU_CLASS,
  TABLET_WIDTH,
  OVERFLOW_HIDDEN_CLASS,
} from "../../lib/constants";

import {
  closeLocalMenu,
  closeModalCards,
  isEscPressed,
  runFnByWinResize,
} from "../../lib/utils";
import { closeOverlay } from "../../blocks/overlay";

const $BURGER_BTN = $(".js-topline-burger:first");

const $NAV_MENU = $(".js-topline-nav");

const $TABS_CONTAINERS = $(".js-topline-sub-nav-tabs");
const $SUBMENU_CONTAINERS = $("[data-menu-dock]");

export const closeAllSubMenu = () => {
  $SUBMENU_CONTAINERS.removeClass(SHOW_CLASS);
  $NAV_MENU.removeClass(OVERFLOW_HIDDEN_CLASS);
};

const closeSubMenuByItemsHover = () => {
  const $navItems = $(".topline__sub-nav-1-item");
  const $mainItems = $(".js-topline-nav-item-with-submenu");

  $navItems.on("mouseenter", function () {
    const $navItem = $(this);

    if (
      !$navItem.hasClass("js-topline-sub-nav-1-item-with-submenu") &&
      $WINDOW.width() > TABLET_WIDTH
    ) {
      $SUBMENU_CONTAINERS.removeClass(SHOW_CLASS);
    }
  });

  $mainItems.on("mouseenter", function () {
    if ($WINDOW.width() > TABLET_WIDTH) {
      $SUBMENU_CONTAINERS.removeClass(SHOW_CLASS);
    }
  });
};

export const isToplineScroll = () => {
  if ($WINDOW.scrollTop() > 2) {
    $TOPLINE.addClass(SCROLL_CLASS);
  }
};

const toggleToplineShadow = () => {
  $WINDOW.on("scroll", () => {
    $TOPLINE.toggleClass(SCROLL_CLASS, $WINDOW.scrollTop() > 2);
  });

  isToplineScroll();
};

const closeLocalMenuByEscAndClickPress = () => {
  $DOCUMENT.on("click", function ({ target }) {
    if (
      $LOCAL_MENU[0] !== target &&
      $TOPLINE.hasClass(LOCAL_SITE_MENU_CLASS) &&
      $BURGER_BTN[0] !== target &&
      !$(target).parents(".js-topline").length
    ) {
      closeLocalMenu();
      $BODY.removeClass(BODY_LOCK_CLASS);

      checkLocalMenuStatus();
    }
  });

  $DOCUMENT.on("keyup", (event) => {
    if (isEscPressed(event) && $TOPLINE.hasClass(LOCAL_SITE_MENU_CLASS)) {
      closeLocalMenu();
      $BODY.removeClass(BODY_LOCK_CLASS);

      checkLocalMenuStatus();
    }
  });
};

const checkLocalMenuStatus = () => {
  if ($TOPLINE.hasClass(LOCAL_SITE_MENU_CLASS)) {
    $TOPLINE
      .addClass(BORDER_BOTTOM_CLASS)
      .removeClass(SCROLL_CLASS)
      .removeClass(DIRECTIONS_MENU_CLASS);
    $BODY.addClass(BODY_LOCK_CLASS);
  } else {
    isToplineScroll();
    closeAllSubMenu();
    $BODY.removeClass(BODY_LOCK_CLASS);
    $TOPLINE.removeClass(BORDER_BOTTOM_CLASS);
  }
};

const toggleLocalMenu = () => {
  $BURGER_BTN.on("click", function () {
    closeOverlay();
    closeModalCards();
    closeAllSubMenu();

    $TOPLINE.toggleClass(LOCAL_SITE_MENU_CLASS);
    $LOCAL_MENU.toggleClass(SHOW_CLASS);

    checkLocalMenuStatus();
  });
};

const copyLocalMenuItemsWithSubMenuToSubmenu = () => {
  const $items = $(".js-topline-nav-item-with-submenu");

  $.each($items, function (_, el) {
    const $item = $(el);
    const $submenu = $item.parent().find(".js-topline-sub-nav-tabs");

    $submenu.prepend(
      $item
        .clone()
        .removeClass()
        .addClass(
          "topline__sub-nav-1-item topline__sub-nav-1-item--title accessibility-link"
        )
    );
  });
};

const switchLocalSubMenu = () => {
  const switchLocalSubMenuFns = () => {
    $.each($TABS_CONTAINERS, function (_, el) {
      const $tabsContainer = $(el);
      const $tabsShell = $tabsContainer.find("[data-menu-tab]");

      $.each($tabsShell, function (_, el) {
        const $el = $(el);

        const tabLink = $el.find(".js-topline-sub-nav-1-item-with-submenu");
        const tabBtn = $el.find(".js-topline-sub-nav-item-open-btn");

        if ($WINDOW.width() <= L_TABLET_WIDTH) {
          tabBtn.on("click", function () {
            const $tab = $(this);

            if (!$tab.hasClass(ACTIVE_CLASS)) {
              $SUBMENU_CONTAINERS.removeClass(SHOW_CLASS);
              $(`[data-menu-dock="${$el.attr("data-menu-tab")}"]`).addClass(
                SHOW_CLASS
              );

              $NAV_MENU.addClass(OVERFLOW_HIDDEN_CLASS);
            }
          });

          tabLink.unbind("mouseenter");
        } else {
          tabLink.bind("mouseenter", function () {
            const $tab = $(this);

            if (!$tab.hasClass(ACTIVE_CLASS)) {
              $SUBMENU_CONTAINERS.removeClass(SHOW_CLASS);
              $(`[data-menu-dock="${$el.attr("data-menu-tab")}"]`).addClass(
                SHOW_CLASS
              );
            }
          });
        }
      });
    });
  };

  (function closeLocalSubmenuByBackBtn() {
    const $backBtns = $(".js-topline-sub-nav-back-btn");

    $.each($backBtns, function (_, el) {
      const $backBtn = $(el);

      $backBtn.on("click", function () {
        closeAllSubMenu();
      });
    });
  })();

  switchLocalSubMenuFns();
  runFnByWinResize(switchLocalSubMenuFns, L_TABLET_WIDTH);
};

export const topLineFunctions = () => {
  closeLocalMenuByEscAndClickPress();
  toggleToplineShadow();
  toggleLocalMenu();
  copyLocalMenuItemsWithSubMenuToSubmenu();
  switchLocalSubMenu();
  closeSubMenuByItemsHover();

  $WINDOW.on("resize", function () {
    if ($WINDOW.width() > L_TABLET_WIDTH) {
      isToplineScroll();

      $TOPLINE.removeClass(LOCAL_SITE_MENU_CLASS);
      $BODY.removeClass(BODY_LOCK_CLASS);
    }
  });
};
